import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const NogapleftImg = ({data}) => {
  
  return (
    <>
      <div className="container-fluid p-0 m-0 bgeYantra">
        <Row className="p-0 m-0 align-items-center " id="MobileResponsiveSection">
          <Col md={6} className="p-0 m-0">
            <img
              className="p-0 m-0 img-fluid"
              src={data.RightImgNogap}
              loading="lazy"
              id="RightImgNogap"
            />
          </Col>
          <Col md={6} className="bgeYantra py-2 p-md-4 m-0">
            <h2 className="fs-48">{data.NogapHeading}</h2>
            <p className="fst-italic">{data.paragraphItalic}</p>
            <p className="fs-16">{data.paragraphDetail}</p>
            <Row className="my-2 ">
              {data.Heading?.map((item, index)=>(
                 <Col md={6} className="mt-1">
                 <ul>
                   <li className="">
                       <b key={index}>{item.ListHeading} </b>
                     <br></br>
                     {item.ListParagraph}
                   </li>
                 </ul>
               </Col>
              ))}
            </Row>
            <h3 className="fs-32">{data.NogapSubheading}</h3>
            <Row className="align-items-baseline">
              {data.Categories?.map((item, index)=>(
                   <Col md={4} className="col-4 p-md-auto p-0" key={index} >
                   <img  src={item.ServiceImg} loading="lazy" id="categoryImg"
                    className="p-2 m-auto d-block"/>
                       <p className="px-0 text-center fs-14">
                           {item.ServiceText}
                       </p>
                   </Col>
              ))}
                <Link to="/contact-us">
                            <Button id="btnCTA" className="fw-normal my-2">Get a Quote</Button>
                            </Link>
            </Row>
                
                
          </Col>
        </Row>
        
      </div>
    </>
  );
};

export default NogapleftImg;
